import { render, staticRenderFns } from "./ChatLog.vue?vue&type=template&id=6f8ad1ed&scoped=true&"
import script from "./ChatLog.vue?vue&type=script&lang=js&"
export * from "./ChatLog.vue?vue&type=script&lang=js&"
import style0 from "./ChatLog.vue?vue&type=style&index=0&id=6f8ad1ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ad1ed",
  null
  
)

export default component.exports